import { applyMiddleware, compose, createStore } from "redux"
import createSagaMiddleware from "redux-saga"
import { requestsPromiseMiddleware } from "redux-saga-requests"

import rootReducer from "./rootReducer"
import rootSaga from "./rootSaga"

const w = window
const sagaMiddleware = createSagaMiddleware()

export default function configureStore(preloadedState) {
  const middlewares = []
  if (process.env.NODE_ENV === "development") {
    const { createLogger } = require("redux-logger")
    const logger = createLogger({
      collapsed: (getState, action, logEntry) => !logEntry.error,
    })
    middlewares.push(sagaMiddleware, logger)
  } else {
    middlewares.push(sagaMiddleware)
  }
  let allMiddleware = applyMiddleware(requestsPromiseMiddleware(), ...middlewares)

  // 使用redux dev tools
  if (w.__REDUX_DEVTOOLS_EXTENSION__ && typeof w.__REDUX_DEVTOOLS_EXTENSION__ === "function") {
    allMiddleware = compose(allMiddleware, w.__REDUX_DEVTOOLS_EXTENSION__ && w.__REDUX_DEVTOOLS_EXTENSION__())
  }

  // 如果要正常使用是使用 const store = createStore(reducer, applyMiddleware())
  const store = createStore(rootReducer, preloadedState, allMiddleware)

  sagaMiddleware.run(rootSaga)

  return store
}
